<template>
  <Dialog
    :title="type === 'add' ? '新增用户' : '修改用户'"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="cancel"
  >
    <el-form ref="formRef" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="昵称" prop="nickName">
        <el-input
          v-model.trim="form.nickName"
          placeholder="请输入昵称"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="userName">
        <el-input
          v-model.trim="form.userName"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password" v-if="type === 'add'">
        <el-input
          v-model.trim="form.password"
          show-password
          placeholder="6~14位，仅数字/英文/标点"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="roleIds">
        <el-select
          multiple
          :multiple-limit="1"
          v-model="form.roleIds"
          placeholder="请选择"
          style="width: 100%;"
        >
          <el-option
            v-for="item in roleOptionList"
            :key="item.id"
            :label="item.roleName"
            :value="item.roleId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号" prop="phonenumber">
        <el-input
          v-model.trim="form.phonenumber"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button plain round size="small" @click="cancel">取 消</el-button>
      <el-button plain round size="small"
        type="primary"
        :loading="submitLoading"
        @click="submitForm"
        >确 定</el-button
      >
    </div>
  </Dialog>
</template>

<script>
import { userSave, userUpdate, userInfo } from "@/api/system/user";
import { roleList } from "@/api/system/role";
import { validatePassword } from "@/utils/validate";

const defaultForm = () => ({
  userId: "",
  userName: "",
  nickName: "",
  password: "",
  roleIds: "",
  phonenumber: "",
  userSex: ""
});

export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      type: "add",
      roleOptionList: [],
      form: defaultForm()
    };
  },
  computed: {
    rules() {
      return {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        nickName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" }
        ],
        roleIds: [{ required: true, message: "请选择角色", trigger: "change" }],
        phonenumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        userSex: [{ required: true, message: "请选择性别", trigger: "change" }]
      };
    }
  },
  methods: {
    async open(type, row = {}) {
      this.type = type;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      const roleListResult = await roleList();
      this.roleOptionList = roleListResult.data.rows;
      if (type === "edit") {
        try {
          const result = await userInfo(row.userId);
          const data = result.data.data;
          data.roleIds = (data.roles || []).map(item => item.roleId);
          this.form = { ...data, password: "" };
        } catch (e) {
          this.cancel();
        }
      } else {
        this.form = defaultForm();
      }
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return false;
      }
      this.submitLoading = true;
      const payload = { ...this.form };
      if (this.type === "edit" && !payload.password) {
        delete payload.password;
      }
      try {
        const result =
          this.type === "edit"
            ? await userUpdate(payload)
            : await userSave(payload);

        this.$message.success(
          this.type === "edit" ? "编辑成功！" : "保存成功！"
        );
        this.cancel();
        this.$emit("success");
      } catch (e) {
      } finally {
        this.submitLoading = false;
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = defaultForm();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/system/User/UserForm.vue